var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLost = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download 1",
    clipPath: "url(#clip0_7027_208854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x9B\xBE\xE5\xB1\x82_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 11.5C2.46292 11.5 -1.49267e-06 9.03708 -9.61651e-07 6C-4.3063e-07 2.96292 2.46292 0.5 5.5 0.500001C8.53708 0.500001 11 2.96292 11 6C11 9.03708 8.53708 11.5 5.5 11.5ZM7.32132 5.95375L6.05797 7.2171L6.05797 3.10449C6.05797 2.9446 5.92454 2.81117 5.76465 2.81117L5.23535 2.81117C5.07546 2.81117 4.94203 2.94295 4.94203 3.10449L4.94203 7.2171L3.67872 5.95375C3.56448 5.83955 3.37812 5.83955 3.26388 5.95375L2.88962 6.32801C2.77542 6.44225 2.77676 6.62999 2.88962 6.74285L5.25094 9.10417C5.31776 9.17099 5.41135 9.19823 5.5 9.18589C5.58865 9.19823 5.68228 9.17099 5.7491 9.10417L8.11042 6.74285C8.22328 6.62999 8.22462 6.44225 8.11042 6.32801L7.73616 5.95375C7.62192 5.83955 7.43557 5.83955 7.32132 5.95375Z",
    fill: "#FF4B55"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7027_208854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLost);
export default ForwardRef;